import { ButtonProps } from '@carvana/ds-button';
import { AnalyticsAttributes } from '@carvana/merch-components/contracts';
import { absoluteBaseUrl } from '~/constants/environment';
import { useDealershipId } from '~/context/dealership/StaticContext';
import { useGetVehicleId } from '~/context/vdp/VehicleContext';
import buildDealershipUrl from '~/utilities/dealership/buildDealershipUrl';
import DealershipCtaButton from './DealershipCtaButton';

type OwnProps = ButtonProps & {
  'data-analytics-id': string | null;
  'data-analytics-attributes'?: AnalyticsAttributes;
  'data-testid'?: string;
};

export default function DealershipTermsCtaButton(props: OwnProps) {
  const dealershipId = useDealershipId();
  const vehicleId = useGetVehicleId();

  return (
    <DealershipCtaButton
      {...props}
      href={buildDealershipUrl(
        `${absoluteBaseUrl}/vehicle/${vehicleId}?wmo=softpull&refSource=dealership`,
        dealershipId,
        'softpull'
      )}
      text="Get your terms"
      variant="secondary"
      data-adobe-id="get-your-terms"
    />
  );
}
